import { useGetRestaurantIdentityQuery } from '@/app/api/hubApi';
import { useGetConfigurationQuery } from '@/app/api/resourceApi';
import type { RestaurantIdentity, RestaurantConfiguration } from '@/types';

export interface UseRestaurantResult {
  identity: RestaurantIdentity | undefined;
  config: RestaurantConfiguration | undefined;
  isLoading: boolean;
  isError: boolean;
  error: unknown;
  identityError: unknown;
  configError: unknown;
  /** DF-0257 — rejoue les deux chargements sans rechargement de page. */
  refetch: () => void;
}

export function useRestaurant(uuid: string): UseRestaurantResult {
  const id = useGetRestaurantIdentityQuery(uuid, { skip: !uuid });
  const cfg = useGetConfigurationQuery(uuid, { skip: !uuid });
  return {
    identity: id.data,
    config: cfg.data,
    isLoading: id.isLoading || cfg.isLoading,
    isError: id.isError || cfg.isError,
    error: id.error ?? cfg.error,
    identityError: id.error,
    configError: cfg.error,
    refetch: () => {
      id.refetch();
      cfg.refetch();
    },
  };
}
